import React from "react";

const FigureCard = ({ title, value, textColor }) => {
  return (
    <div className="bg-card p-4 shadow-card border-main border-[2px]">
      <h3 className="text-muted text-sm font-medium">{title}</h3>
      <p className={`text-2xl font-bold ${textColor}`}>{value}</p>
    </div>
  );
};

export default FigureCard;
